import type { AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getPropertyToUpdate } from '../../utils/coverablesUtil';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../selectors/getOnsaCurrentProductSelector';

type OnsaCoverableDTO = Partial<
    NonNullable<AllCoverablesOnsaDTO[keyof AllCoverablesOnsaDTO]>[number]
>;

export function useUpdateCoverableInformation(): {
    updateCoverableInformation: (objectToUpdate: OnsaCoverableDTO) => void;
} {
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const { flavourName = '', fixedId = '' } = useRecoilValue(getOnsaCurrentProductSelector) ?? {};

    const updateCoverableInformation = (objectToUpdate: OnsaCoverableDTO): void => {
        const propertyToUpdate = getPropertyToUpdate(flavourName);
        const flavour = coverables[propertyToUpdate as keyof AllCoverablesOnsaDTO];
        if (!flavour) return;
        const coverableIndex = flavour.findIndex((coverable) => coverable.fixedId === fixedId);
        const updatedFlavour = [...flavour];
        updatedFlavour[coverableIndex] = {
            ...updatedFlavour[coverableIndex],
            ...objectToUpdate
        };
        const updatedAllCoverables = {
            ...coverables,
            [propertyToUpdate as keyof AllCoverablesOnsaDTO]: updatedFlavour
        };
        setCoverables(updatedAllCoverables);
    };

    return { updateCoverableInformation };
}
